import WSConnectManager from "@/pages/WebSocketConnect.vue";

import DashboardLayout from "@/pages/Dashboard/Layout/DashboardLayout.vue";
//import AuthLayout from "@/pages/Dashboard/Pages/AuthLayout.vue";

// Dashboard pages
import Dashboard from "@/pages/Dashboard/Dashboard.vue";
import DashboardSeller from "@/pages/Dashboard/DashboardSeller.vue";
import FullScreenMap from "@/pages/Dashboard/Maps/FullScreenMap.vue";

const routes = [
  {
    path: "/login",
    name: "Login",
    component: () => import("@/pages/Dashboard/Pages/Login.vue"),
  },
  {
    path: "/",
    component: WSConnectManager,
    children: [
      {
        path: "",
        redirect: "/maps",
      },
      {
        path: "",
        component: DashboardLayout,
        children: [
          {
            path: "maps",
            name: "MAP",
            components: { default: FullScreenMap },
            meta: { requiresAuth: true },
          },
          {
            path: "sellers/:sellerPath",
            name: "Energy Producer Agent Dashboard",
            components: { default: DashboardSeller },
            meta: { requiresAuth: true },
          },
          {
            path: "customers/:customerPath",
            name: "Your Dashboard",
            components: { default: Dashboard },
            meta: { requiresAuth: true },
          },
        ],
      },
    ],
  },
];

export default routes;
